export const introProductPriceCalculator = (
  baseProductPrice: number,
  yearsOfMembership: number,
  disabilityIsApprovedOrSelected: boolean,
  memberAge: number,
  yearsOfProduction: number,
  isPastPresident: boolean
): number => {
  let productPrice: number = baseProductPrice;

  if (
    yearsOfMembership >= 50 ||
    disabilityIsApprovedOrSelected ||
    isPastPresident
  )
    return 0;

  if (memberAge >= 65 && (yearsOfMembership >= 25 || yearsOfProduction >= 20))
    productPrice -= 365;

  return productPrice;
};

export default {};
